// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1xiHt","actionsCol":"EnrolledClinics_actionsCol__Meqca"};